import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'lum-ag-grid-caret-cell-renderer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './ag-grid-caret-cell-renderer.component.html',
  styleUrls: ['./ag-grid-caret-cell-renderer.component.scss'],
})
export class AgGridCaretCellRendererComponent implements ICellRendererAngularComp {
  @Output()
  toggleExpand :EventEmitter<any> = new EventEmitter();

  showCaret :boolean = false;
  isExpanded :boolean = false;
  params :any;

  agInit(params :any) :void {
    this.params = params;
    this.showCaret = params.showCaret;
  }

  refresh(params :any) :boolean {
    return false;
  }

  onToggleExpand(event :Event) :void {
    event.stopPropagation(); // Prevent row selection on caret click
    this.isExpanded = !this.isExpanded;
    if (this.isExpanded) {
      this.params.node.setExpanded(true);
    } else {
      this.params.node.setExpanded(false);
    }
  }
}
